export default "/_next/static/src/lib/assets/rive/bbff9eaff94fcbc80455971e5859d548.riv";